"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseStyleParams = void 0;
var tslib_1 = require("tslib");
var lodash_1 = tslib_1.__importDefault(require("lodash"));
var constants_1 = require("./constants");
var findSiteColorByThemeName = function (siteColors, themeName) {
    return lodash_1.default.find(siteColors, function (color) { return color.reference === themeName; });
};
var recoveryColorsMap = {
    thumbnailButtonsColor: 'rgba(255,255,255,1)',
    thumbnailOverlayColor: 'rgba(0,0,0,0.4)',
};
var withRecoveryColors = function (colors) {
    return lodash_1.default.mapValues(colors, function (_a, key) {
        var _b = _a === void 0 ? {} : _a, value = _b.value, themeName = _b.themeName;
        if (value && value.includes('NaN')) {
            return {
                themeName: themeName,
                value: recoveryColorsMap[key] || value,
            };
        }
        return { value: value, themeName: themeName };
    });
};
var parseStyleParams = function (_a, isResponsive) {
    var styleParams = _a.styleParams, siteColors = _a.siteColors, siteTextPresets = _a.siteTextPresets;
    if (isResponsive === void 0) { isResponsive = false; }
    var booleans = styleParams.booleans, colors = styleParams.colors, numbers = styleParams.numbers, fonts = styleParams.fonts;
    var themeToSiteColorMapping = (0, lodash_1.default)(constants_1.FALLBACK_COLOR_TO_SITE_COLOR_MAPPING)
        .values()
        .uniq()
        .reduce(function (acc, themeName) {
        var _a;
        var colorTheme = findSiteColorByThemeName(siteColors, themeName);
        return colorTheme
            ? tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[themeName] = {
                themeName: themeName,
                value: colorTheme.value,
            }, _a)) : acc;
    }, {});
    var fallbackColors = lodash_1.default.mapValues(constants_1.FALLBACK_COLOR_TO_SITE_COLOR_MAPPING, function (theme) { return themeToSiteColorMapping[theme]; });
    var fallbackFonts = lodash_1.default.mapValues(isResponsive
        ? constants_1.FALLBACK_FONT_TO_TEXT_PRESET_MAPPING_RESPONSIVE
        : constants_1.FALLBACK_FONT_TO_TEXT_PRESET_MAPPING, function (fontKey) {
        if (siteTextPresets[fontKey]) {
            var _a = siteTextPresets[fontKey], fontFamily = _a.fontFamily, value = _a.value, size = _a.size, style = _a.style, weight = _a.weight, editorKey = _a.editorKey;
            return {
                editorKey: editorKey,
                family: fontFamily,
                size: parseInt(size, 10),
                preset: fontKey,
                style: {
                    bold: weight !== 'normal',
                    italic: style === 'italic',
                },
                value: value,
            };
        }
        return {};
    });
    var mappedColors = lodash_1.default.mapValues(colors, function (color) {
        return themeToSiteColorMapping[color.value]
            ? tslib_1.__assign(tslib_1.__assign({}, color), { value: themeToSiteColorMapping[color.value].value }) : color;
    });
    return tslib_1.__assign(tslib_1.__assign({}, styleParams), { booleans: booleans, colors: withRecoveryColors(tslib_1.__assign(tslib_1.__assign({}, fallbackColors), mappedColors)), numbers: numbers, fonts: tslib_1.__assign(tslib_1.__assign({}, fallbackFonts), fonts) });
};
exports.parseStyleParams = parseStyleParams;
//# sourceMappingURL=parse.js.map